import React from "react";
import { Outlet } from "react-router-dom/dist";

const Providers = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Providers;
